import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const featuredFinds = categories.slice(0, 4);

const featuredImages = [
  'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20fashion%20product%20photography%20of%20sneakers%20and%20shoes%20on%20a%20clean%20soft%20cream%20background%2C%20subtle%20warm%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20simple%20composition%2C%20modern%20e-commerce%20aesthetic&width=600&height=500&seq=featured-cat-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20fashion%20product%20photography%20of%20hoodies%20and%20sweaters%20on%20a%20clean%20soft%20cream%20background%2C%20subtle%20warm%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20simple%20composition%2C%20modern%20e-commerce%20aesthetic&width=600&height=500&seq=featured-cat-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20fashion%20product%20photography%20of%20t-shirts%20on%20a%20clean%20soft%20cream%20background%2C%20subtle%20warm%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20simple%20composition%2C%20modern%20e-commerce%20aesthetic&width=600&height=500&seq=featured-cat-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20fashion%20product%20photography%20of%20jackets%20on%20a%20clean%20soft%20cream%20background%2C%20subtle%20warm%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20simple%20composition%2C%20modern%20e-commerce%20aesthetic&width=600&height=500&seq=featured-cat-04&orientation=landscape',
];

export default function FeaturedSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full uppercase tracking-wider">
            Featured
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-3">
            Featured Finds &amp; Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            Handpicked CSSBuy spreadsheet discoveries and expert guides to level up your shopping
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredFinds.map((cat, index) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={featuredImages[index]}
                  alt={`${cat.name} CSSBuy Spreadsheet category`}
                  title={`${cat.name} CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {index === 0 && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider bg-accent-500 text-background-50 rounded-full">
                    Hot
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">
                  Best {cat.name} Finds
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  Curated {cat.name.toLowerCase().replace('/', ' ')} spreadsheet picks
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 md:mt-16">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
            Latest SEO Guides
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {articles.map((article, index) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group block p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <span className="inline-block px-2.5 py-1 mb-3 text-[10px] font-semibold uppercase tracking-wider bg-secondary-100 text-secondary-700 rounded-full">
                  {article.category}
                </span>
                <h4 className="text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors mb-2 leading-snug">
                  {article.title}
                </h4>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                  <span className="text-xs font-medium text-primary-600 group-hover:translate-x-0.5 transition-transform inline-flex items-center gap-1">
                    Read More
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}